// DUPLICATION
export const SET_SHOW_MODAL = "SET_SHOW_DUPLICATION_MODAL";
export const SET_DUPLICATION_DATA = "SET_DUPLICATION_DATA";
